export const VERIFICATION_STATUS = {
  VERIFIED: 'verified',
  PENDING: 'pending',
  REJECTED: 'rejected',
  UPDATE_REQUESTED: 'update-requested'
};
